import React, { Fragment, useEffect, useState } from 'react';
import { Route, Switch, Router, useParams } from 'react-router-dom'
import ZPageheader from '../components/ZPageheader';
import { Redirect } from 'react-router';
// import { connect } from 'react-redux';
import styles from '../components/appStyles-jss';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
// import Organization from '../containers/Organization/Organization'
import Dashboard from "../containers/Dashboard";
import FundTransfer from '../containers/FundTransfer';
import Transaction from '../containers/Transaction';
import QrToken from '../containers/QrToken';

// const sidebarOpen = false
function Header(props) {
    // const [open, setOpen] = useState(false)
    const {
        classes
    } = props

    return (
        <Fragment>
            <ZPageheader show={true} history={props.history} />

            <main className={classNames(classes.content, classes.contentPaddingLeft)} id="mainContent">
                <section className={classNames(classes.mainWrap, classes.sidebarLayout)}>
                    <Switch>
                         <Route path="/dashboard" component={Dashboard} />
                         <Route path="/fundtransfer" component={FundTransfer} />
                         <Route path="/transaction" component={Transaction} />  
                         <Route path="/QrToken" component={QrToken} />                   
                    </Switch>
                </section>
            </main>

        </Fragment>

        // <div>
        //     dc xcxzcxzc
        // </div>
    );
}





// const mapDispatchToProps = dispatch => ({
//     userDetails: (user) => dispatch(userDetails(user)),
//     removeFailedMsg: () => dispatch(removeFailedMsg()),

// });
// const mapStateToProps = state => {
//     return {
//         userId: state.header.userID,
//         subId: state.header.subId,
//         isAdmin: state.header.isAdmin,
//         roleId: state.header.roleId,
//         offlineTime: state.header.offlineTime,
//         screenshotEnable: state.header.screenshotEnable
//     };
// };

// const DashboardMapped = connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(Header);

export default withStyles(styles)(Header);

